import { API } from "../api";
import { FIRST_MILE_ORDER_LIST } from "../constants/url.constant";
import { setError } from "./Indicator";

export const REQUEST_FIRST_MILE_SHIPING_LIST =
  "REQUEST_FIRST_MILE_SHIPING_LIST";
export const SET_FIRST_MILE_SHIPING_LIST = "SET_FIRST_MILE_SHIPING_LIST";

export const setFirstMileShipingList = (data) => {
  return {
    type: SET_FIRST_MILE_SHIPING_LIST,
    payload: data
  };
};

export const firstMileShipingList = ({ limit, page }) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_FIRST_MILE_SHIPING_LIST });
    try {
      const res = await API.get(`${FIRST_MILE_ORDER_LIST}`, {
        params: {
          limit: limit,
          page: page
        }
      });

      return dispatch(setFirstMileShipingList(res));
    } catch (error) {
      console.log(error);
      dispatch(setError("Somehing went wrong!"));
    }
  };
};

const initialState = {
  isLoading: false,
  loaded: false,
  columns: [],
  data: [],
  totalRows: {}
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case REQUEST_FIRST_MILE_SHIPING_LIST:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    case SET_FIRST_MILE_SHIPING_LIST:
      return {
        ...state,
        isLoading: false,
        loaded: true,
        columns: payload.columns,
        rows: payload.rows,
        totalRows: payload.count
      };
    default:
      return state;
  }
}
